import { Howl } from "howler";

import { muted } from '../stores/global.js';

const MAX = 0.15;

const h = new Howl({
	src: ["assets/audio/fx.mp3"],
	sprite: {
		click: [0, 181],
		pop: [162, 156],
		up: [300, 300],
		down: [612, 356],
		zoom: [993, 4135],
		zoom2: [5160, 3854]
	},
});

h.volume(MAX);

muted.subscribe($muted => {
	h.volume($muted ? 0 : MAX);
});

export default function fx(val) {
	h.play(val);
}